module.exports = __webpack_public_path__ + "static/media/image.dadba127.svg";